import type { SVGProps } from 'react';

const SvgIsolated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="#30354A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.646 6.22072C15.7504 6.26249 15.8399 6.33467 15.903 6.42794C15.9661 6.5212 15.9999 6.63129 16 6.74398V13.2562C15.9999 13.3689 15.9661 13.4789 15.903 13.5722C15.8399 13.6655 15.7504 13.7377 15.646 13.7794L10.2085 15.9597C10.0744 16.0134 9.92484 16.0134 9.79075 15.9597L4.35325 13.7794C4.24898 13.7375 4.1596 13.6653 4.09665 13.5721C4.03369 13.4788 4.00003 13.3688 4 13.2562V6.74398C4.00003 6.63137 4.03369 6.52135 4.09665 6.42809C4.1596 6.33484 4.24898 6.26261 4.35325 6.22072L9.58225 4.12392L9.58525 4.12317L9.79075 4.04047C9.92506 3.98651 10.0749 3.98651 10.2093 4.04047L10.4148 4.12317L10.4178 4.12392L15.646 6.22072ZM14.6155 6.61692L10 8.46788L5.3845 6.61692L4.75 6.87179V7.17251L9.625 9.12722V15.0831L10 15.2334L10.375 15.0831V9.12797L15.25 7.17326V6.87254L14.6155 6.61692Z"
      fill="#F0B90B"
    />
  </svg>
);

export default SvgIsolated;
